import { isMobile } from 'mobile-device-detect';
import { configuration as countryConfiguration } from '../../countries/austria/configuration';
import { adSlots, mobileAdSlots } from './adSlotsConfig';
// TODO: Data copied from immowelt.de, check if everything is correct before using it!
export const brandConfig = {
    brand: 'immoweltat',
    headerBiddingScriptUrl: '', // '//cdn-a.yieldlove.com/v2/yieldlove.js?immowelt.at',
    gptScriptUrl: '', // 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
    adSense: {
    //   url: 'https://www.google.com/adsense/search/ads.js',
    //   function: `(function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(
    // arguments)},g[o]['t']=1*new Date})(window,'_googCsa');`,
    //   pubId: 'partner-pub-1420484732098233',
    //   styleId: '1331207826',
    },
    googleTagManager: {},
    adSlots: isMobile ? mobileAdSlots : adSlots,
    ...countryConfiguration,
};
